"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.to-string.js");
var _objectSpread2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _form = require("@/utils/form");
var _staff = require("@/api/staff");
var _role = require("@/api/role");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var employeeFieldRequired = ["username", "name", "phone", "password", "roleId"];
var StaffModal = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(StaffModal, _Vue);
  var _super = (0, _createSuper2.default)(StaffModal);
  function StaffModal() {
    var _this;
    (0, _classCallCheck2.default)(this, StaffModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "$refs", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingSubmit", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "visible", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "form", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "rules", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "status", "create");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "merchantRoles", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "roles", []);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadingReset", false);
    return _this;
  }
  (0, _createClass2.default)(StaffModal, [{
    key: "fetchRoles",
    value: function fetchRoles() {
      var _this2 = this;
      _role.roleApi.getRoles().then(function (res) {
        return _this2.roles = res.data;
      });
    }
  }, {
    key: "created",
    value: function created() {
      var _this3 = this;
      this.fetchRoles();
      employeeFieldRequired.forEach(function (field) {
        _this3.$set(_this3.rules, field, _form.ruleRequired);
      });
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$confirm("Xác nhận xóa nhân viên?", "Cảnh báo", {
                  confirmButtonText: "Xóa",
                  cancelButtonText: "Không",
                  type: "warning"
                });
              case 2:
                _context.prev = 2;
                this.loadingSubmit = true;
                _context.next = 6;
                return _staff.staffApi.delete(this.form.id);
              case 6:
                this.$notify({
                  title: "Thông báo",
                  message: "Xóa thành công",
                  type: "success"
                });
                this.visible = false;
                this.$emit("submit:success");
              case 9:
                _context.prev = 9;
                this.loadingSubmit = false;
                return _context.finish(9);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "handleBlock",
    value: function () {
      var _handleBlock = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var msg, msgSuccess;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                msg = this.form.isBlock ? "Bạn chắc chắn muốn mở khóa?" : "Bạn chắc chắn muốn khóa tài khoản này?";
                _context2.next = 3;
                return this.$confirm(msg, "Cảnh báo", {
                  cancelButtonText: "Không",
                  confirmButtonText: "Có",
                  type: "warning"
                });
              case 3:
                msgSuccess = this.form.isBlock ? "Mở khóa thành công" : "Khóa tài khoản thành công";
                if (!this.form.isBlock) {
                  _context2.next = 9;
                  break;
                }
                _context2.next = 7;
                return _staff.staffApi.unblock(this.form.id);
              case 7:
                _context2.next = 11;
                break;
              case 9:
                _context2.next = 11;
                return _staff.staffApi.block(this.form.id);
              case 11:
                this.$notify({
                  title: "Thông báo",
                  message: msgSuccess,
                  type: "success"
                });
                this.visible = false;
                this.$emit("submit:success");
              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function handleBlock() {
        return _handleBlock.apply(this, arguments);
      }
      return handleBlock;
    }()
  }, {
    key: "handleResetPwd",
    value: function () {
      var _handleResetPwd = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4() {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.$prompt("Nhập mật khẩu mới", "Reset mật khẩu", {
                  confirmButtonText: "Reset",
                  cancelButtonText: "Đóng",
                  inputPattern: /(\w){6}/,
                  inputErrorMessage: "Mật khẩu ít nhất 6 ký tự"
                  // @ts-ignore
                }).then( /*#__PURE__*/function () {
                  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(_ref) {
                    var value;
                    return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            value = _ref.value;
                            _this4.loadingReset = true;
                            _context3.prev = 2;
                            _context3.next = 5;
                            return _staff.staffApi.reset(_this4.form.id, {
                              newPassword: value
                            });
                          case 5:
                            _this4.$notify({
                              title: "Reset mật khẩu",
                              message: "Thành công",
                              type: "success"
                            });
                          case 6:
                            _context3.prev = 6;
                            _this4.loadingReset = false;
                            return _context3.finish(6);
                          case 9:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3, null, [[2,, 6, 9]]);
                  }));
                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
      function handleResetPwd() {
        return _handleResetPwd.apply(this, arguments);
      }
      return handleResetPwd;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.$refs.form.validate();
              case 2:
                valid = _context5.sent;
                if (!valid) {
                  _context5.next = 14;
                  break;
                }
                _context5.prev = 4;
                this.loadingSubmit = true;
                _context5.next = 8;
                return _staff.staffApi.create({
                  staff: this.form,
                  roleId: this.form.roleId || 0
                });
              case 8:
                this.$notify({
                  title: "Successfully",
                  message: "Create successfully",
                  type: "success"
                });
                this.$emit("submit:success");
                this.visible = false;
              case 11:
                _context5.prev = 11;
                this.loadingSubmit = false;
                return _context5.finish(11);
              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4,, 11, 14]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee6() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.$refs.form.validate();
              case 2:
                valid = _context6.sent;
                if (!valid) {
                  _context6.next = 14;
                  break;
                }
                _context6.prev = 4;
                this.loadingSubmit = true;
                _context6.next = 8;
                return _staff.staffApi.update(this.form.id, {
                  staff: this.form,
                  roleId: this.form.roleId || 0
                });
              case 8:
                this.$notify({
                  title: "Successfully",
                  message: "Update successfully",
                  type: "success"
                });
                this.$emit("submit:success");
                this.visible = false;
              case 11:
                _context6.prev = 11;
                this.loadingSubmit = false;
                return _context6.finish(11);
              case 14:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4,, 11, 14]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "deleteData",
    value: function () {
      var _deleteData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee7() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.$confirm("Xác nhận xóa nhân viên?", "Xác nhận", {
                  cancelButtonText: "Không",
                  confirmButtonText: "Xóa",
                  type: "warning"
                });
              case 2:
                _context7.next = 4;
                return _staff.staffApi.remove(this.form.id);
              case 4:
                this.$notify.success({
                  title: "Xóa nhân viên",
                  message: "Thành công"
                });
                this.visible = false;
                this.$emit("submit:success");
              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));
      function deleteData() {
        return _deleteData.apply(this, arguments);
      }
      return deleteData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {
        phone: ""
      };
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      console.log("handleUpdate", data);
      this.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        roleId: data.role && data.role.id
      });
      this.visible = true;
      this.status = "update";
    }
  }]);
  return StaffModal;
}(_vuePropertyDecorator.Vue);
StaffModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default
  }
})], StaffModal);
var _default = StaffModal;
exports.default = _default;